/* ------------------------------------- MATERIAL UI --------------------------------------- */
import { Button, Container, Stack, Typography } from '@mui/material';
/* ------------------------------------- REACT JS ------------------------------------------ */
import { useLocation, useNavigate } from 'react-router-dom';
/* ------------------------------------- DEPENDENCIES -------------------------------------- */

import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/close-circle-outline';

/* ------------------------------------- COMPONENTS ---------------------------------------- */
import Page from '../components/Page';
import { useTranslation } from '../common/LocalizationProvider';
import { MyClubForm } from '../components/myClub';

export default function MyClubEdit() {
  const t = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Page title={t('editClub_Title')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('editClub')}
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate('/myclub', { replace: true })}
            startIcon={<Icon icon={plusFill} />}
            color="secondary"
          >
            {t('btn_Cancel')}
          </Button>
        </Stack>
        <MyClubForm groupId={location.state !== null ? location.state.id : null} />
      </Container>
    </Page>
  );
}
